import comp from '../components/barrel';
import svg from '../js/svg';
import config from '../js/config';
import O from '../js/core';
import U from '../js/utils';

export default {
  async prepare() {
    this.application_uuid = thsPage.vars.application_uuid;

    const vars = {};
    vars.application_uuid = this.application_uuid;
    this.recipe.methods.push(await O.mPOST('application/get-app-summary-v2', vars));
    this.recipe.methods.push(await O.mPOST('wills/get-will-withdrawal', vars));
  },
  async render() {
    const rec = this.recipe.methods;

    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },
  async loadPage(data) {
    const appSummary = data['application/get-app-summary-v2'].data;
    const withdrawalList = data['wills/get-will-withdrawal'].data;

    const withdrawalPartyUUIDs = withdrawalList.map((entry) => entry.party_uuid);

    if (withdrawalPartyUUIDs.includes(appSummary.party1)) {
      appSummary.party1 = null;
    }

    if (withdrawalPartyUUIDs.includes(appSummary.party2)) {
      appSummary.party2 = null;
    }

    await this.buildRecordDiv(appSummary);
    await this.buildRecordList(withdrawalList);
  },
  async buildRecordList(data) {
    U.hide('listCard');

    const withdrawalListDiv = U.id('withdrawalListDiv');
    withdrawalListDiv.innerHTML = '';

    const table = U.divAtt('table', 'class', 'w-full');

    // HEADER
    const thead = U.divAtt('thead', 'class', 'w-full');
    const headRow = thead.insertRow();

    const h1 = headRow.insertCell(0);
    h1.innerHTML = 'Date';
    const h2 = headRow.insertCell(1);
    h2.innerHTML = 'Recorded By';
    const h3 = headRow.insertCell(2);
    h3.innerHTML = 'Party';
    const h4 = headRow.insertCell(3);
    h4.innerHTML = 'Withdrawn';
    const h5 = headRow.insertCell(4);
    h5.innerHTML = 'Date of Death';
    const h6 = headRow.insertCell(5);
    h6.innerHTML = 'Reason';
    const h7 = headRow.insertCell(6);
    h7.innerHTML = '';
    thead.appendChild(headRow);
    table.appendChild(thead);

    // Body
    const tbody = U.divAtt('tbody');
    table.appendChild(tbody);

    if (data.length) {
      data.forEach(async (row) => {
        const willRow = tbody.insertRow();
        const r1 = willRow.insertCell(0);
        r1.innerHTML = await U.formatDate(row.created_date);
        const r2 = willRow.insertCell(1);
        r2.innerHTML = `${row.created_by_f_name} ${row.created_by_s_name}`;
        const r3 = willRow.insertCell(2);
        r3.innerHTML = `${row.party_f_name} ${row.party_s_name}`;
        const r4 = willRow.insertCell(3);
        r4.innerHTML = await U.formatDate(row.withdrawal_date);
        const r5 = willRow.insertCell(4);
        r5.innerHTML = await U.formatDate(row.death_date);
        const r6 = willRow.insertCell(5);
        r6.innerHTML = row.withdrawal_reason;
        const r7 = willRow.insertCell(6);
        const download_onclick = `thsTab.downloadFile('${row.file_uuid}')`;
        const linkSVG = svg.download(download_onclick);
        r7.appendChild(linkSVG);
      });
      U.unhide('listCard');
    }

    withdrawalListDiv.appendChild(table);
  },
  async buildRecordDiv(appSummary) {
    const recordWithdrawalDiv = U.id('recordWithdrawalDiv');
    recordWithdrawalDiv.innerHTML = '';

    if (!appSummary.party1 && !appSummary.party2) {
      U.hide('withdrawalCard');
      return;
    }

    const div = U.divAtt('div');

    const partyDiv = U.divAtt('div', 'class', 'grid grid-cols-2 gap-4 mt-12 mb-8');

    if (appSummary.party1) {
      const party1Tgl = await comp.toggle_v2({
        elID: 'party1Tgl',
        isChecked: false,
        labelName: `Party 1 - ${appSummary.party1_f_name} ${appSummary.party1_s_name}`,
        onToggleChange: null,
        elValue: appSummary.party1,
      });

      partyDiv.appendChild(party1Tgl);
    }
    if (appSummary.party2) {
      const party2Tgl = await comp.toggle_v2({
        elID: 'party2Tgl',
        isChecked: false,
        labelName: `Party 2 - ${appSummary.party2_f_name} ${appSummary.party2_s_name}`,
        onToggleChange: null,
        elValue: appSummary.party2,
      });
      partyDiv.appendChild(party2Tgl);
    }

    const dateFileDiv = U.divAtt('div', 'class', 'grid grid-cols-2 gap-4 my-8');

    const textArea = await comp.textarea('notesDiv', '', 'Notes', true);
    const textArea2 = await comp.textarea('reasonDiv', '', 'Reason', true);
    const withdrawalDate = await comp.inputDate('withdrawalDate', null, 'Date of Withdrawal', true);
    const deathDate = await comp.inputDate('deathDate', null, 'Date of Death', true);
    const fileInputDiv = await comp.inputFile({elID: 'pdfUpload', labelName: 'Withdrawal Document:', accept: 'application/pdf', requiredYN: true});

    dateFileDiv.appendChild(withdrawalDate);
    dateFileDiv.appendChild(deathDate);

    div.appendChild(partyDiv);
    div.appendChild(dateFileDiv);
    div.appendChild(textArea);
    div.appendChild(textArea2);
    div.appendChild(fileInputDiv);

    recordWithdrawalDiv.prepend(div);
    U.unhide('withdrawalCard');
  },
  async recordWillWithdrawal() {
    const tgls = document.querySelectorAll('.tglSwitch');
    const notesDiv = U.id('notesDiv');
    const reasonDiv = U.id('reasonDiv');
    const withdrawalDate = U.id('withdrawalDate');
    const deathDate = U.id('deathDate');
    const pdfUpload = U.id('pdfUpload');

    // Check if elements exist
    if (!notesDiv || !reasonDiv || !withdrawalDate || !deathDate || !pdfUpload) {
      comp.errorBox('Error', 'Form elements not found. Please refresh the page.');
      return;
    }

    const checkedTogglesValues = Array.from(tgls)
      .filter((toggle) => toggle.checked)
      .map((toggle) => toggle.value);

    U.id('notesDiv').classList.remove('input-error');
    U.id('reasonDiv').classList.remove('input-error');
    U.id('withdrawalDate').classList.remove('input-error');
    U.id('deathDate').classList.remove('input-error');
    U.id('pdfUpload').classList.remove('input-error');

    tgls.forEach((tgl) => {
      tgl.classList.remove('input-error');
    });

    let isValid = true;
    const errors = [];

    if (!checkedTogglesValues.length) {
      tgls.forEach((tgl) => {
        tgl.classList.add('input-error');
      });
      isValid = false;
      errors.push('Please select at least one party');
    }

    if (!notesDiv.value) {
      notesDiv.classList.add('input-error');
      isValid = false;
      errors.push('Notes is required');
    }

    if (!reasonDiv.value) {
      reasonDiv.classList.add('input-error');
      isValid = false;
      errors.push('Reason is required');
    }

    if (!withdrawalDate.value) {
      withdrawalDate.classList.add('input-error');
      isValid = false;
      errors.push('Date of Withdrawal is required');
    }

    if (!deathDate.value) {
      deathDate.classList.add('input-error');
      isValid = false;
      errors.push('Date of Death is required');
    }

    if (!pdfUpload.files[0]) {
      pdfUpload.classList.add('input-error');
      isValid = false;
      errors.push('Withdrawal document is required');
    } else {
      if (pdfUpload.files[0].type !== 'application/pdf') {
        U.id('pdfUpload').classList.add('input-error');
        isValid = false;
        errors.push('File must be a PDF');
      }
    }

    if (!isValid) {
      comp.errorBox('Validation Error', errors.join('<br>'));
      return;
    }

    // Check if application_uuid is set
    if (!this.application_uuid) {
      comp.errorBox('Error', 'Application UUID not found. Please refresh the page.');
      return;
    }

    const formData = new FormData();

    formData.append('party_uuid_str', JSON.stringify(checkedTogglesValues));
    formData.append('application_uuid', this.application_uuid);
    formData.append('uploadFile', pdfUpload.files[0]);
    formData.append('death_date', deathDate.value);
    formData.append('withdrawal_date', withdrawalDate.value);
    formData.append('withdrawal_notes', notesDiv.value);
    formData.append('withdrawal_reason', reasonDiv.value);

    try {
      const hdrs = await O.getAuthHdrs();
      
      if (!hdrs || !hdrs.token) {
        throw new Error('Authentication failed. Please log in again.');
      }

      const response = await fetch(`${config.apiURL}wills/ins-will-withdrawal`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${hdrs.token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        
        if (response.status == 404) {
          throw new Error('No signed will found for application');
        } else {
          throw new Error(`Withdrawal failed: ${response.status} - ${errorText}`);
        }
      }

      const result = await response.json();
      
      comp.toast('Will withdrawal recorded successfully');
      await this.render();
    } catch (error) {
      comp.errorBox('Error', error.message || 'Failed to record will withdrawal. Please try again.');
    }
  },
  async downloadFile(file_uuid) {
    const vars = {};
    vars.file_uuid = file_uuid;

    O.PREP([await O.mPOST('files/get-file-url', vars)])
      .then(async (res) => {
        window.open(res['files/get-file-url'].data.signedUrl, '_blank');
      })
      .catch(() => {});
  },
};
